import React, { FC } from 'react';
import { StyledButton } from './styled';
import { IButtonProps } from './typed';

const Button: FC<IButtonProps> = ({ ...props }) => {
  return <StyledButton {...props} />;
};

export default Button;
